import { Box, Typography, Grid, TextField, MenuItem, Tooltip, Popover, } from "@mui/material";
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { useSelector } from "react-redux";
import { useState } from "react";
const GPAL = ({ data,
    code,
    screen,
    updateHistoryBlock,
    updateObstetricsHistories,
    edit }) => {
    const constantReducer = useSelector((state) => state.constantReducer);
    const definitions = constantReducer.historyConfig;
    const order = ["g", "t", "p", "a", "l",];
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedKey, setSelectedKey] = useState(null);
    const handleClick = (event, key) => {
        setAnchorEl(event.currentTarget);
        setSelectedKey(key);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedKey(null);
    };

    const getDefinition = (key) => {
        switch (key) {
            case "g":
                return definitions?.gravidaDefenition;
            case "t":
                return definitions?.termDefenition;
            case "p":
                return definitions?.preTermDefenition;
            case "a":
                return definitions?.abortionDefenition;
            case "l":
                return definitions?.livingChildrenDefenition;
            default:
                return "";
        }
    };

    return (
        <Grid
            container
            justifyContent="space-between"
            sx={{
                width: {
                    xs: "100%",
                    sm: "80%",
                    md: !screen ? "80%" : '100%',
                    lg: !screen ? "90%" : '90%',
                    xl: !screen ? "90%" : '90%',
                },
                justifySelf: 'center',
                flexWrap: { xs: 'nowrap', md: 'wrap' },
                gap: { xs: 0.5, md: 0 },
            }}
        >
            {order.map((key) => (
                <Grid
                    size={{ xs: true, sm: 3, md: 2 }}
                    key={key}
                    sx={{
                        flexDirection: 'row',
                        display: 'flex',
                        flex: { xs: '1 1 0', md: undefined },
                        minWidth: { xs: 0, md: undefined },
                        position: 'relative',
                        justifyContent: 'center',
                    }}
                >
                    <Box
                        sx={{
                            width: {
                                xs: '100%',
                                sm: "80%",
                                md: screen ? '40px' : '35px',
                                lg: screen ? '40px' : '35px',
                                xl: screen ? '40px' : '35px',
                            },
                            borderRadius: '6px',
                            // backgroundColor: "rgba(236, 251, 253, 1)",
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            py: 0.5,
                            height: {
                                xs: screen ? '52px' : '44px',
                                md: screen ? '53px' : '38px',
                                lg: screen ? '58px' : '38px',
                                xl: screen ? '56px' : 55
                            },
                            margin: { xs: 0, md: screen ? 1 : 0 },
                            border: '1px solid #919191'
                            // boxShadow: '0 1px 10px rgba(0,0,0,0.1)',
                        }}
                    >
                        <Typography fontWeight="bold" color="#525252" sx={{ fontSize: !screen ? { xs: '14px', xl: '21px', lg: '15px', md: '15px' } : { xs: '13px', xl: '20px', lg: '20px', md: '17px' }, fontFamily: 'Roboto Flex', lineHeight: 1.1 }}>
                            {key.toUpperCase()}
                        </Typography>
                        {
                            !screen ?
                                <Typography color="#525252" fontWeight="bold" sx={{ fontSize: { xs: '15px', xl: '20px', lg: '17px', md: '17px' }, lineHeight: 1.1 }}>
                                    {data[key] || 0}
                                </Typography>
                                :
                                <TextField
                                    select
                                    size="small"
                                    placeholder="YY"
                                    value={
                                        key == "g" ? data?.gravida || data?.gtpal?.gravida || 0 :
                                            key == "t" ? data?.termCount || data?.gtpal?.termCount || 0 :
                                                key == "p" ? data?.preTermCount || data?.gtpal?.preTermCount || 0 :
                                                    key == "l" ? data?.liveBirthCount || data?.gtpal?.liveBirthCount || 0 :
                                                        data?.abortionCount || data?.gtpal?.abortionCount || 0
                                    }
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                border: 'none',
                                            },
                                            padding: '0px',
                                            height: '24px',
                                            width: { xs: '100%', md: '38px' },
                                            '& .MuiSelect-select': {
                                                color: '#525252',
                                                fontSize: { xs: '14px', xl: '20px', lg: '19px', md: '17px' },
                                                fontWeight: 'bold',
                                                paddingLeft: { xs: '8px', md: '15px' },
                                                display: 'flex',
                                                alignItems: 'center',
                                            },
                                            '&.Mui-disabled .MuiSelect-select': {
                                                color: '#525252 !important',
                                                WebkitTextFillColor: '#525252',
                                            },
                                        },
                                        '& .MuiSelect-icon': {
                                            width: '45px',
                                            marginRight: { xs: '-16px', xl: '-25px', lg: '-25px', md: '-22px' },
                                            fontSize: '20px'
                                        },
                                    }}
                                    onChange={(event) => {
                                        const value = Number(event.target.value);

                                        const fieldMap = {
                                            g: "gravida",
                                            t: "termCount",
                                            p: "preTermCount",
                                            a: "abortionCount",
                                            l: "liveBirthCount",
                                        };

                                        updateHistoryBlock(
                                            code,
                                            [fieldMap[key]],
                                            value
                                        );

                                        if (key === "t") {
                                            updateObstetricsHistories(code, value, "TERM");
                                        }

                                        if (key === "p") {
                                            updateObstetricsHistories(code, value, "PRETERM");
                                        }

                                        if (key === "a") {
                                            updateObstetricsHistories(code, value, "ABORTION");
                                        }
                                    }}
                                    disabled={!edit}
                                >
                                    {[{ name: 0 }, { name: 1 }, { name: 2 }, { name: 3 }, { name: 4 }, { name: 5 }, { name: 6 },].map((option) => (
                                        <MenuItem key={option.name} value={option.name} sx={{
                                            '&:hover': {
                                                backgroundColor: '#D3D3D3',
                                                color: '#fff',
                                            },
                                            '&.Mui-selected': {
                                                backgroundColor: 'grey',
                                                color: '#fff',
                                            },
                                            '&.Mui-selected:hover': {
                                                backgroundColor: 'grey',
                                            },

                                            '&.Mui-focusVisible': {
                                                backgroundColor: 'grey',
                                            },

                                            '&.Mui-selected.Mui-focusVisible': {
                                                backgroundColor: 'grey',
                                            },
                                        }}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                        }
                    </Box>
                    {screen && <Tooltip title={key == 'g' ? definitions?.gravidaDefenition : key == 't' ? definitions?.termDefenition : key == 'p' ? definitions?.preTermDefenition : key == 'l' ? definitions?.livingChildrenDefenition : definitions?.abortionDefenition} arrow
                        placement="top">
                        <InfoOutlineIcon fontSize='small' sx={{ color: '#4FCDF4', position: 'absolute', top: { xs: 2, md: '22px' }, right: { xs: -2, md: 'auto' }, marginLeft: { md: '60px' }, height: '11px', width: '11px', cursor: 'pointer', display: { md: 'flex', xs: 'none' }, zIndex: 10, }} />
                    </Tooltip>}
                    <InfoOutlineIcon
                        fontSize='small'
                        sx={{
                            color: '#4FCDF4',
                            position: 'absolute',
                            top: { xs: 2, md: '22px' },
                            right: { xs: -2, md: 'auto' },
                            marginLeft: { md: '60px' },
                            height: '11px',
                            width: '11px',
                            cursor: 'pointer',
                            display:{md:'none',xs:'flex'}
                        }}
                        onClick={(e) => handleClick(e, key)}
                    />
                    <Popover
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                        }}
                        slotProps={{
                            paper: {
                                elevation: 0,
                                sx: {
                                    boxShadow: "none",
                                    backgroundColor: "#F2F2F2",
                                    border: "none",
                                    borderRadius: 2,
                                },
                            },
                        }}
                    >
                        <Typography sx={{ p: 1, maxWidth: 220, fontSize:'13px' }}>
                            {getDefinition(selectedKey)}
                        </Typography>
                    </Popover>
                </Grid>
            ))}
        </Grid>
    );
};

export default GPAL;
